import React from "react";

import cx from "classnames";

import Tooltip from "@components/Tooltip";

import {Tag, TagSize} from "../interfaces";
import styles from "./TagIcon.scss";

export type TagIconProps = {
  tag: Tag;
  showName?: boolean;
  showTooltip?: boolean;
  size?: TagSize;
  wrapperClassName?: string;
  tagNameClassName?: string;
};

export default function TagIcon({
  tag,
  size = TagSize.Small,
  showName = false,
  showTooltip = true,
  wrapperClassName,
  tagNameClassName,
}: TagIconProps): JSX.Element {
  let tagNode = (
    // The tabindex is necessary for now so that sighted keyboard-only users can see
    // what the Tag's name is. A rewrite of this component may be more appropriate.
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <span className={wrapperClassName} tabIndex={0}>
      <img
        className={cx(styles.tagImg, styles[size])}
        src={tag.url}
        alt={tag.value}
      />
      {showName && (
        <span className={cx(styles.tagName, tagNameClassName)}>
          {tag.value}
        </span>
      )}
    </span>
  );

  if (showTooltip) {
    tagNode = (
      <Tooltip className={styles.tagTooltip} content={tag.value}>
        {tagNode}
      </Tooltip>
    );
  }

  return tagNode;
}
